const BackgroundSpinner = ({
  className = 'h-24 w-24 text-blue-300 opacity-30',
}) => (
  <svg
    className={`${className} animate-spin-slow`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      d="M12 2 a 10 10 0 0 1 0 20 a 10 10 0 0 1 0 -20"
      strokeDasharray="47.1 15.7"
    />
    <style>{`
      @keyframes spin-slow {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .animate-spin-slow {
        animation: spin-slow 3s linear infinite;
      }
    `}</style>
  </svg>
);

export default BackgroundSpinner;
